import React from 'react';
import ReactDOM from 'react-dom';

import { Popup } from './Popup';

export const PopupSection = props =>
  //eslint-disable-next-line no-undef
  process.env.SERVER
    ? null
    : ReactDOM.createPortal(
        <Popup {...props} />,
        document.getElementById('modal-root')
      );



// WEBPACK FOOTER //
// ./app/components/PopupSection/PopupSection.js